import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { addNotification } from 'actions/notifications/notifications';
import { sizesMap } from './utils.js';

import './style.scss';

/**
 * @param {{ 
 *      filters: Filters, 
 *      selectSize: Function,
 *      sizesCounters: Array,
 * }} props
 */
function VesselsComposition({ selectSize, sizesCounters }) {
    const [_sizesCounters, _setSizesCounters] = useState([]);

    useEffect(() => {
        _setSizesCounters(sizesCounters);
    }, [sizesCounters]);

    const chooseVessel = (vessel) => {
        selectSize(vessel);
    };
    
    return (
        <div>
            {
                _sizesCounters.map((sizesCounter, sIndex) => (
                    <React.Fragment key={`sizesCounter_${sIndex}`}>
                        {
                            sizesCounter.vessel &&
                                <div
                                    className='sizesCounter'
                                    onClick={() => chooseVessel(sizesCounter.vessel)}
                                >
                                    <b className='sizesCounter--vessel'>
                                        {`${sizesCounter.vessel.name} (${sizesCounter.vessel.imoNumber})`}
                                    </b>
                                    <span className='sizesCounter--data'>
                                        {
                                            Object.entries(_.omit(sizesCounter, 'vessel'))
                                                .map((item, index) => (
                                                    <span key={`${item[0]}_${index}}`}>
                                                        <b>{sizesMap[item[0]]}</b>: {item[1]}&nbsp;&nbsp;&nbsp;
                                                    </span>
                                                ))
                                        }
                                    </span>
                                </div>
                        }
                    </React.Fragment>
                ))
            }
        </div>
    );
}

export default connect(
    null,
    dispatch => bindActionCreators(
        {
            addNotification,
        },
        dispatch,
    ),
)(VesselsComposition);

/**
 * 
 * @typedef {import('./Main.jsx').FiltersState} Filters 
 * @typedef {import('./Main.jsx').FiltersStateSetter} FiltersSetter
 */



// WEBPACK FOOTER //
// ./app/components/Vessels/Composition/Composition.jsx